import { useQuery } from '@tanstack/react-query';

import getOperatorBreaks from 'Api/report-attendance-operator-detail/getOperatorBreaks';
import getOperatorBreaksRequest from './model/request/getOperatorBreaksRequest';
import getOperatorBreaksResponse from './model/response/getOperatorBreaksResponse';

const useGetOperatorBreaks = ({ filter, selectedTab }) => {
  return useQuery({
    queryKey: ['report-operator-breaks', filter],
    queryFn: async () => {
      const queries = getOperatorBreaksRequest(filter);

      const response = await getOperatorBreaks(queries);

      const result = getOperatorBreaksResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: selectedTab === 'restViolation',
  });
};

export default useGetOperatorBreaks;
